import IndexNotifiq from "@/Pages/Notifiq/IndexNotifiq.vue";
import AlunosAusentesPage from "@/Pages/Notifiq/AlunosAusentesPage.vue";

export default [
  {
    path: "/notifiq/presencas",
    name: "notifiq.indexNotifiq",
    title: "Presença Notifiq",
    component: IndexNotifiq,
  },
  {
    path: "/notifiq/alunos-ausentes",
    name: "notifiq.alunosAusentes",
    title: "Alunos sem Entrada (3 Dias)",
    component: AlunosAusentesPage,
  },
];
